import React, { PureComponent } from 'react';
// import api from 'helpers/api';
import { connect } from "react-redux";
import Terms from './Content/Terms'
import Privacy from './Content/Privacy'
import './style.scss';
import {acceptTerms} from '../../store/auth-slice';

class TermsAgreement extends PureComponent {

    constructor(props) {
        super(props);
        // console.log(props)
        this.state = {
            privacy: <Privacy />,
            terms: <Terms />,
        }
    }

    redirectToDashboard = async () => {
        const {dispatch, history} = this.props;
        await dispatch(acceptTerms());
        history.push('/dashboard');
        
        /*
        switch (user.role) {
            case 1:
                router.push('/staff/dashboard');
                break;
            case 2:
                router.push('/clinic/account');
                break;
            case 3:
                router.push('/chain/account');
                break;
            case 4:
                router.push('/distributor/dashboard');
                break;
            case 5:
                router.push('/alma/dashboard');
                break;
            default:
                router.push('/login');
                break;
        }
        */
    }

    render() {
        return (
            <div className="main-terms-conditions">
                <h1 className="title">{this.props.match.params.title === 'terms' ? 'Terms and Conditions' : 'Privacy Policy'}</h1>
                <div className="terms-container shadow-box">
                    {this.state[this.props.match.params.title]}
                </div>
                {(this.props.state.auth.user !== null && this.props.match.params.title === 'terms') &&
                    <button
                        type="button"
                        className="agree-button"
                        onClick={this.redirectToDashboard}
                    >
                        Agree
                    </button>
                }
            </div>
        );
    }

}


const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(TermsAgreement);